import { ColDef, ICellRendererParams } from 'ag-grid-community'
import { CurrencyCell, LinkCell } from 'components/core-v2'

import { ApiAccountDashboardNote } from '@/api'
import { PATH } from '@/const'

const NameCell = ({ data: { noteId, noteName } }: ICellRendererParams<ApiAccountDashboardNote>) =>
  noteName === 'Dominion' ? (
    <span>{noteName}</span>
  ) : (
    <LinkCell to={PATH.reportsSingleNote(noteId, 'details')}>{noteName}</LinkCell>
  )

export const COLUMN_DEFS: ColDef[] = [
  { headerName: 'Name', field: 'noteName', minWidth: 200, flex: 2.5, cellRenderer: NameCell },
  {
    headerName: 'Client',
    field: 'client',
    minWidth: 180,
    flex: 2
  },
  { headerName: 'Business unit', field: 'businessUnit', minWidth: 180, flex: 2 },
  { headerName: 'Classification', field: 'taxClassification', minWidth: 200, flex: 1.5 },
  {
    headerName: 'Trades',
    field: 'numberOfActiveAccounts',
    minWidth: 105,
    flex: 1,
    type: 'rightAligned'
  },
  {
    headerName: 'Value',
    field: 'zarValue',
    minWidth: 105,
    flex: 1.5,
    type: 'rightAligned',
    sort: 'desc',
    cellRenderer: CurrencyCell({ fieldName: 'zarValue' })
  }
]

export const DEFAULT_COLUMN_OPTIONS: ColDef = {
  sortable: true,
  unSortIcon: true
}
